module.exports = __webpack_public_path__ + "img/oper-icon1.a1cf581d.png";